require("./Tabs.marko.css");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            tabList: [],
            tabContent: [],
            activeTab: null,
            breakpoint: false
        };
        GState.bind(this, [
            'screen',
            'theme'
        ]);
    },
    onInput: function (input) {
        this.state.tabList = Object.keys(input.tabs);
        this.state.tabContent = Object.values(input.tabs);
        if (this.state.screen.media == 'xs') {
            if (this.state.tabList.length > 3)
                this.state.breakpoint = 2;
        }
        if (this.state.screen.media == 'sm') {
            if (this.state.tabList.length > 6)
                this.state.breakpoint = 5;
        }
        if (this.state.screen.media == 'md') {
            if (this.state.tabList.length > 7)
                this.state.breakpoint = 6;
        }
        if (this.state.screen.media == 'lg') {
            if (this.state.tabList.length > 5)
                this.state.breakpoint = 4;
        }
    },
    onMount: function () {
        this.toggleTab(0, true);
    },
    onUpdate: function () {
        try {
            const tabname = this.state.tabList[this.state.activeTab], tabset = this.state.tabContent[this.state.activeTab], tab = tabset.component || require('../' + (this.state.theme.name || 'default') + '/tabs/' + tabname.toCapitalCase()), {tabs, ...adds} = this.input, view = tab.renderSync({
                    ...tabset,
                    ...adds
                });
            view.replaceChildrenOf($(tabset.anchor)[0]);
        } catch (error) {
            console.log('[Tab] Error: ', error);
        }
    },
    toggleTab: function (index, e) {
        if (e !== true && $('.Tabs li.tab-' + index + ' a.active').length || index == undefined)
            return;
        this.state.activeTab = index;
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Tabs.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_forRange = require("marko/dist/runtime/helpers/for-range"),
    Locale_template = require("../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_attrs0 = {
        "class": "Tabs"
      },
    marko_attrs1 = {
        id: "scroll-container",
        "class": "tab-content px-1 pt-2"
      },
    marko_attrs2 = {
        "class": "nav nav-tabs px-1",
        role: "tablist"
      },
    marko_attrs3 = {
        "class": "dropdown-menu dropdown-menu-right theme-bg"
      },
    marko_attrs4 = {
        "class": "align-middle"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("40bf05"),
    marko_node0 = marko_createElement("span", {
        "class": "align-middle"
      }, "6", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("i", {
          "class": "bx bx-dots-vertical-rounded"
        }, null, null, 0),
    marko_attrs5 = {
        "class": "font-medium-2 cursor-pointer nav-item px-2 py-50",
        "data-toggle": "tab"
      },
    marko_attrs6 = {
        "class": "nav nav-tabs px-1",
        role: "tablist"
      },
    marko_attrs7 = {
        "class": "align-middle"
      },
    marko_attrs8 = {
        "class": "blue-grey-text text-center",
        style: "padding:10% 0;"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  if (state.tabList.length) {
    if (state.breakpoint) {
      out.be("ul", marko_attrs2, "1", component);

      marko_forRange(0, state.breakpoint, 1, function(index) {
        var $keyValue$0 = "@" + ("li-" + index),
            $keyScope$0 = "[" + ($keyValue$0 + "]");

        out.be("li", {
            "class": marko_classValue("tab-" + index)
          }, $keyValue$0, component, null, 1);

        out.be("a", {
            "class": marko_classValue("nav-link btn-lg " + (state.activeTab == index ? " active" : "")),
            "data-toggle": "tab",
            href: state.tabContent[index].anchor
          }, "2" + $keyScope$0, component, null, 0, {
            onclick: __component.d("click", "toggleTab", false, [
                index
              ])
          });

        out.be("span", marko_attrs4, "3" + $keyScope$0, component);

        Locale_tag({
            text: state.tabContent[index].title
          }, out, __component, "4" + $keyScope$0);

        out.ee();

        out.ee();

        out.ee();
      });

      out.be("li", null, "@li-00", component);

      out.e("a", {
          "class": marko_classValue("nav-link btn-lg dropdown-toggle " + (state.activeTab > state.breakpoint ? " active" : "")),
          "data-toggle": "dropdown"
        }, "5", component, 1)
        .n(marko_node0, component);

      out.be("div", marko_attrs3, "8", component);

      var $for$0 = 0;

      marko_forRange(state.breakpoint + 1, state.tabList.length - 1, 1, function(index) {
        var $keyScope$1 = "[" + (($for$0++) + "]");

        out.be("div", marko_attrs5, "9" + $keyScope$1, component, null, 0, {
            onclick: __component.d("click", "toggleTab", false, [
                index
              ])
          });

        Locale_tag({
            text: state.tabContent[index].title
          }, out, __component, "10" + $keyScope$1);

        out.ee();
      });

      out.ee();

      out.ee();

      out.ee();
    } else {
      out.be("ul", marko_attrs6, "11", component);

      marko_forOf(state.tabList, function(title, index) {
        var $keyValue$2 = "@" + ("li-" + index),
            $keyScope$2 = "[" + ($keyValue$2 + "]");

        out.be("li", {
            "class": marko_classValue("tab-" + index)
          }, $keyValue$2, component, null, 1);

        out.be("a", {
            "class": marko_classValue("nav-link btn-lg " + (state.activeTab == index ? " active" : "")),
            "data-toggle": "tab",
            href: state.tabContent[index].anchor
          }, "12" + $keyScope$2, component, null, 0, {
            onclick: __component.d("click", "toggleTab", false, [
                index
              ])
          });

        out.be("span", marko_attrs7, "13" + $keyScope$2, component);

        Locale_tag({
            text: state.tabContent[index].title
          }, out, __component, "14" + $keyScope$2);

        out.ee();

        out.ee();

        out.ee();
      });

      out.ee();
    }

    out.be("div", marko_attrs1, "15", component);

    marko_forOf(state.tabContent, function({ anchor }, index) {
      var $keyValue$3 = "@" + ("content-" + index),
          $keyScope$3 = "[" + ($keyValue$3 + "]");

      out.e("div", {
          "class": marko_classValue("tab-pane " + (state.activeTab == index ? "active" : "")),
          id: anchor.replace("#", "")
        }, $keyValue$3, component, 1, 1)
        .e("div", marko_attrs8, "16" + $keyScope$3, component, 1)
          .t("Loading...");
    });

    out.ee();
  }

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
